import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreHeading,
  OreSelect,
  OreStack,
  SvgEdit,
} from '@edenredespana/oreneta'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { languagesTranslation } from '@/Shared/ui/sharedTranslation'
import { changeLanguageTranslation } from '@/User/ui/userTranslation'
import { locale } from '@/i18n'

export const ChangeLanguage = (): JSX.Element => {
  const { t } = useTranslation()

  const [isEditing, setIsEditing] = useState(false)
  const [selectedLanguage, setSelectedLanguage] = useState('es')

  const handleEditLanguage = (): void => {
    localStorage.setItem('i18nextLng', selectedLanguage)

    setIsEditing(!isEditing)

    window.location.reload()
  }

  useEffect(() => {
    const currentLanguage = localStorage.getItem('i18nextLng')

    setSelectedLanguage(currentLanguage || 'es')
  }, [])

  return (
    <OreCardContainer>
      <OreCardWrapper space="large">
        <OreHeading as="h2" size="headline-sm">
          {t(changeLanguageTranslation.title)}
        </OreHeading>

        <OreDivider space="medium" />

        <OreStack space="large" placeContent="stretch">
          <OreSelect
            name="languageSelect"
            label={t(changeLanguageTranslation.select.label)}
            disabled={!isEditing}
            onChange={(e): void => setSelectedLanguage(e.target.value)}
            value={selectedLanguage}
          >
            {locale.map(lang => (
              <option key={lang} value={lang}>
                {t(languagesTranslation[lang as keyof typeof languagesTranslation])}
              </option>
            ))}
          </OreSelect>
          <div>
            {!isEditing ? (
              <OreButton
                as="button"
                category="secondary"
                icon={<SvgEdit />}
                onClick={(): void => setIsEditing(true)}
                size="large"
                data-testid="editLanguage"
              >
                {t(changeLanguageTranslation.edit.label)}
              </OreButton>
            ) : (
              <OreButton
                category="primary"
                icon={<SvgEdit />}
                onClick={(): void => handleEditLanguage()}
                size="large"
                data-testid="saveLanguage"
              >
                {t(changeLanguageTranslation.save.label)}
              </OreButton>
            )}
          </div>
        </OreStack>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
